import axios from 'axios'

export const getAccessToken = async (phoneNumber, pin) => {
  const response = await axios.post('https://api-dev-future0.futurestash.com/future0/entry/login-with-pin', {
    phone: `+1${phoneNumber}`,
    pin
  }, { headers: { 'Content-Type': 'application/json' } })
  return response.data.accessToken
}
